module.exports = __webpack_public_path__ + "fonts/Inter-800-latin-ext58.fad2a54.woff2";